import React from 'react';
import {useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { DateCellStyling,ContainerStyling,HeadingStyling,PlainDateCellStyling,ContentCellStyling,TableRowStyling} from './BiogTableStyles';

export default function BiogEducation() {
  const { t } = useTranslation('common');
  
  return (
    <Grid2 flexDirection="row"  sx={ContainerStyling}>
        <TableContainer >
          <Table size="small" aria-label="a dense table">
            <TableBody>
              <TableRow
                key={"1"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="normal" sx={DateCellStyling}>
                  {"1999"}
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"M.A., Künstlerische Therapien"}</Box>
                  <Box sx={{fontWeight : 'bold'}} component='span'> - {"European Graduate School"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, {"Kt. Wallis"}</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"2"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                  {"1984"}
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Master of Fine Arts"}</Box>
                  <Box sx={{fontWeight : 'bold'}} component='span'> - {"John F. Kennedy University"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, {"Berkeley und Orinda, CA"}</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"3"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                  {"1978"}
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Dipl. Architektin ETH"}</Box>
                  <Box sx={{fontWeight : 'bold'}} component='span'> - {"Eidgenössische Technische Hochschule"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, {"Zürich"}</Box>
                </TableCell>
              </TableRow>
              <TableRow sx={{pb:3,m:0}}><TableCell sx={DateCellStyling}></TableCell><TableCell sx={ContentCellStyling}></TableCell></TableRow>
              <TableRow
                key={"4"}
              >
                <TableCell component="td" padding="none" scope="row" sx={PlainDateCellStyling}>
                  {"1994-99"}
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Schule für Gestaltung"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'> - {"Basel"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, {"Kurse"}</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"5"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={PlainDateCellStyling}>
                  {"1986"}
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"California College of Arts and Crafts"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'> - {"Oakland, CA"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, {"Kurse"}</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"6"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={PlainDateCellStyling}>
                  {"1983"}
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"University of California"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'> - {"Berkeley, CA"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, {"Kurse"}</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"7"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={PlainDateCellStyling}>
                  {"1982"}
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Boston University, Program in Artisanry"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'> - {"Boston, MA"}</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"8"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={PlainDateCellStyling}>
                  {"1978-82"}
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Kunstgewerbeschule und Werkseminar"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'> - {"Zürich"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, {"Kurse"}</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"9"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={PlainDateCellStyling}>
                  {"1978"}
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'normal'}} component='span'>{"Studienreise nach Mexico und Guatemala"}</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"10"}
                sx={{ '&:last-child td, &:last-child th': {border: 'none' ,margin:0} }}
              >
                <TableCell component="td" padding="none" scope="row" sx={PlainDateCellStyling}>
                  {"1974-76"}
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Königliche Dänische Kunstakademie"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'> - {"Kopenhagen, Dänemark"}</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"11"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={PlainDateCellStyling}>
                  {"1975"}
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Kunsthochschule"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'> - {"Holbaek, Dänemark"}</Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
    </Grid2>
  )
}
